import styled from '@emotion/styled';
import {
  useFloating,
  useHover,
  useInteractions,
  safePolygon,
  offset,
  useClick,
  useDismiss,
} from '@floating-ui/react-dom-interactions';
import Image from 'next/image';
import type { PropsWithChildren } from 'react';
import { useState } from 'react';
import type { TooltipDivProps } from './TooltipDiv';
import ToolTipDiv from './TooltipDiv';
import helpIcon from '@/public/images/ic-help.svg';

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HelpTooltip = ({ children, ...tooltipDivStyle }: PropsWithChildren<TooltipDivProps>) => {
  const [open, setOpen] = useState(false);
  const { context, x, y, reference, floating, strategy } = useFloating({
    open: open,
    placement: 'top',
    onOpenChange: setOpen,
    middleware: [offset(15)],
  });
  const { getReferenceProps, getFloatingProps } = useInteractions([
    useClick(context, {
      ignoreMouse: true,
    }),
    useDismiss(context),
    useHover(context, {
      handleClose: safePolygon(),
      mouseOnly: true,
    }),
  ]);

  const referenceProps = getReferenceProps({ ref: reference });
  const floatingProps = getFloatingProps({ ref: floating });

  return (
    <>
      <IconWrapper {...referenceProps}>
        <Image
          src={helpIcon}
          alt="help"
        />
      </IconWrapper>
      {open && (
        <ToolTipDiv
          {...floatingProps}
          {...tooltipDivStyle}
          position={strategy}
          top={y ?? 0}
          left={x ?? 0}
        >
          {children}
        </ToolTipDiv>
      )}
    </>
  );
};

export default HelpTooltip;
